










import {Component, Vue} from 'vue-property-decorator';
import {namespace} from "vuex-class";
import {RegisterCompanyCustomerRequestDTO} from "@/dto/request/rccr/RegisterCompanyCustomerRequestDTO";
import FileUpload from "@/components/common/FileUpload.vue";
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import RCCRService from "@/services/request/RCCRService";
import CCDRService from "@/services/request/CCDRService";
import CCDR_DTO from "@/dto/request/сcdr/CCDR_DTO";

const AppModule = namespace("App");

@Component({
  components: {SingleFileHolder}
})
export default class CustomerCCDR extends Vue {

  @AppModule.Action
  private startLoading!: () => void

  @AppModule.Action
  private stopLoading!: () => void

  private newFile: FileMetaDTO | null = null;

  request: CCDR_DTO | null = null;

  mounted() {
    this.loadRequest();
  }

  loadRequest() {
    this.startLoading();
    CCDRService.getPublic(this.id).then(
        response => {
          this.request = response.data;
          this.stopLoading();
        },
        error => {
          this.stopLoading();
          console.log(JSON.stringify(error));
        }
    );
  }

  get id() {
    return this.$route.params.id;
  }

  onNewFileUploaded(file: FileMetaDTO) {
    this.startLoading();
    CCDRService.uploadCCDRDocument(this.id, file.id).then(
        response => {
          this.$modal.hideAll();
          this.newFile = null;
          this.loadRequest();
        },
        error => {
          console.log(JSON.stringify(error))
          this.stopLoading();
        }
    );
  }


}
